import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OutsideNotifier from '../../../OutsideNotifier';
import $ from 'jquery';

class PlayerRecomendationPopUpMob extends Component {


    componentDidMount(){
        $($.find(".si-main-component")).removeClass("si-high-zindex");
    }

    closePopUp = (e, val) => {
        e.stopPropagation();
        this.props.showHidePlayerRecomendationPopUpMob(val);
    }

    render() {
        const { trans, onRecomendationPopUpClose } = this.props;

        return <div className="si-modal-wrap">
            <OutsideNotifier handler={(e) => this.closePopUp(e, false)}>
                <div className="si-common-popup si-suggest-popup">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-new-filter"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-title">{trans.recomendPlayer ? trans.recomendPlayer : "Recommended players"}</div>
                            <div className="si-more-info">
                                <span>{trans.makeEachPlayerCt ? trans.makeEachPlayerCt : "Make each pick count!"}</span>
                                <span>{trans.recomendFromUefa ? trans.recomendFromUefa : "Use recommendations from our categorised player lists put together by UEFA experts."}</span>
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap" onClick={(e) => { this.closePopUp(e, false) }}>
                        <div className="si-btn si-btn-secondary-wb">
                            <span>{trans.gtIt ? trans.gtIt : "Got It"}</span>
                        </div>
                    </div>

                </div>
            </OutsideNotifier>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlayerRecomendationPopUpMob));


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerRecomendationPopUpMob.js